import { useState } from "react";
import { colors, Font, Gap } from "../styles/standards";
// import { Constants } from "../constants/textconstants"; // No longer needed for translatable strings
import { ActionButton } from "./button"; // This component needs to use t() internally
import { useNavigate } from "react-router-dom";
import { post } from "../config/api";
import { InfoPopUp } from "./infoPopuop"; // This component needs to use t() internally
import { useSelector } from "react-redux";
import { useTranslation } from '../i18n/useTranslation'; // Import useTranslation hook

export const Concent = ({
  phoneNumber,
  isNewUser,
  retailer,
  oldPhone,
  userID,
  territoryID,
  creatingUser,
}) => {
  const [selected, setSelected] = useState(true); // This controls the checkbox, which needs to be translated too
  const [loader, setLoader] = useState(false);
  const [showExisting, setShowExisting] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // Declare state for error message
  const navigate = useNavigate();
  const { t } = useTranslation(); // Initialize useTranslation

  const retailers = useSelector((state) => state.retailers.retailers);

  // Helper function to fetch retailer data
  const fetchRetailerDetails = (phone) => {
    return retailers.find((element) => element.mobile_number === phone) || {};
  };

  const requestOTP = async () => {
    await localStorage.setItem('brp_mobile_number', oldPhone);
    await localStorage.setItem("mobile_number", phoneNumber);

    // Check if survey is already completed
    if (
      retailers.some(
        (el) =>
          el.mobile_number === phoneNumber && el.survey_status === "closed"
      )
    ) {
      window.alert(t('survey_completed_on_number')); // Translate alert
      navigate(-1);
      return;
    }

    // Check if survey is in progress
    const isInProgress = retailers.some(
      (el) =>
        el.mobile_number === phoneNumber && el.survey_status === "in_progress"
    );

    if (!isInProgress) {
      setLoader(true);
      const data = {
        user_id: userID,
        mobile_number: phoneNumber,
        territory_code: territoryID,
      };

      if (oldPhone !== phoneNumber) {
        data["brp_mobile_number"] = oldPhone;
      }

      post("/otp/send", data)
        .then(async (response) => {
          console.log(response)
          if (response.status === 409) {
            setLoader(false);
            const errorResponse = response; // Assuming errorResponse is directly the response object
            if (errorResponse?.status === 409) {
             
              window.alert(
                `${errorResponse.message}`
              ); // Translate alert with interpolation
              navigate(-1);
            } else {
              window.alert(t('something_went_wrong')); // Translate alert
            }
          }else{
            setLoader(false);
            if(creatingUser){
              await localStorage.setItem("createnewuser", "true");
            }

            navigate("/verify_otp", {
              state: {
                phoneNumber,
                isNewUser,
                retailer,
                userID,
                territoryID,
                creatingUser,
              },
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoader(false); // Ensure loader is turned off on error
          window.alert(t('something_went_wrong')); // Translate alert for generic error
        });
    } else {
      setShowExisting(true);
    }
  };

  return (
    <>
      {showExisting && (
        <InfoPopUp
          close={async () => {
            setShowExisting(false);

            // Fetch retailer details
            const retailer_data = fetchRetailerDetails(phoneNumber);

            // Update localStorage
            await localStorage.setItem("mobile_number", phoneNumber);
            await localStorage.setItem("customer_id", retailer_data.customer_id);
            await localStorage.setItem("createnewuser", "false");

            // Navigate to step1
            navigate("/step1", {
              state: {
                isNewUser: false,
                retailer: retailer_data,
                userID,
                territoryID,
                createNewUser: false,
                mobile_number: phoneNumber,
              },
            });
          }}
          heading={t('survey_in_progress')} // Translate heading
          text={
            errorMessage ||
            t('found_survey_in_progress') // Translate default text
          }
        />
      )}

      {/* Checkbox for consent */}
      <div style={Style.container} onClick={() => setSelected(!selected)}>
        <div style={selected ? Style.Selected : Style.NotSelected}>
          {selected && <i className="fa fa-check"></i>}
        </div>
        <span style={Style.concent}>{t('concent')}</span> {/* Translate concent text */}
      </div>

      <ActionButton
        onPress={() => {
          requestOTP();
        }}
        text={t('request_otp')} // Translate button text
        loader={loader}
        isEnabled={selected}
      />
    </>
  );
};

const Style = {
  Selected: {
    height: 25,
    width: 25,
    background: colors.Blue_Heilight,
    borderRadius: 3,
    color: colors.White,
    fontSize: 14,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: `1px solid ${colors.Blue_Heilight}`,
    cursor: "pointer" // Added cursor for clickability
  },
  NotSelected: {
    height: 25,
    width: 25,
    border: `1px solid ${colors.Blue_Dark}`,
    borderRadius: 3,
    cursor: "pointer" // Added cursor for clickability
  },
  concent: {
    ...Font.RobotoMedium,
    color: colors.Blue_Dark,
    fontSize: 13,
    display: "block",
    marginLeft: 10,
    cursor: "pointer" // Added cursor for clickability
  },
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center", // Align items vertically in the center
    marginBottom: Gap.standardGap // Add some margin bottom for spacing
  },
};